import { Badge, Link } from '@mui/material';
import { useQueryClient } from 'react-query';
import { Link as RouterLink } from 'react-router-dom';
import { UseTableCellProps } from 'react-table';
import { Product } from 'shared/types';

export default function ProductDetailColumn(props: UseTableCellProps<Product>) {
    const queryClient = useQueryClient();
    const {
        row: { original },
    } = props;

    const hasCache = queryClient.getQueryData(['product', original.productCode]);
    const quantityBreaksUsed = original.quantityBreaksUsed === 'Y';
    return (
        <Badge title='Quantity Break Used' color='secondary' variant='dot' invisible={!quantityBreaksUsed}>
            <Link
                color={hasCache ? 'secondary' : 'primary'}
                component={RouterLink}
                to={`products/${original.productCode}`}
            >
                {original.productName || 'No Name'}
            </Link>
        </Badge>
    );
}
